import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { LoginService } from "../authentication/login.service";
import { LocalStorageService } from "../helper/local-storage.service";
import { CommonService } from "../helper/common.service";

@Injectable()
export class CheckKycActive implements CanActivate {
  constructor(
    private router: Router,
    private loginService: LoginService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.loginService.isLoggedIn == true) {
      // let kycVerified = this.localStorageService.getLocalStorage('kyc_verified');
      // console.log("kycVerified",kycVerified)
      // if(kycVerified == 0){
      //     this.commonService.toasterService(0, "Please complete your KYC.");
      //     this.router.navigate(['/dashboard']);
      //     return false;
      // }
      let user = this.localStorageService.getUser();
      if (user.is_kyc_verified == 0 && user.is_kyc_rejected != 1) {
        this.commonService.toasterService(2, "Your KYC verification is in progress.");
        this.router.navigate(["/dashboard"]);
        return false;
      }
      if (user.is_kyc_rejected == 1) {
        this.commonService.toasterService(0, "Your KYC verification has been failed.");
        this.router.navigate(["/dashboard"]);
        return false;
      }
      
    }
    return true;
  }
}
